import { useEffect, useState } from 'react';

const MINUTE_MS = 60 * 1000;

export default function useMinuteTick(enabled = true) {
  const [now, setNow] = useState(() => Date.now());

  useEffect(() => {
    if (!enabled) return undefined;
    const timer = setInterval(() => setNow(Date.now()), MINUTE_MS);
    return () => clearInterval(timer);
  }, [enabled]);

  return now;
}
